import { LockResetTwoTone } from '@mui/icons-material';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import {
  Avatar,
  Box,
  Button,
  Divider,
  List,
  ListItem,
  ListItemText,
  Popover,
  Typography,
  styled
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import LogoutConfirmation from 'src/components/LogoutConfirmationDialog';
import ResetPasswordAdmin from 'src/components/ResetPasswordDialog';
import useAuth from 'src/hooks/useAuth';
const UserBoxButton = styled(Button)(
  ({ theme }) => `
        padding: ${theme.spacing(0, 1)};
        height: ${theme.spacing(7)};
`
);

const MenuUserBox = styled(Box)(
  ({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(2)};
`
);

const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
);

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.secondary.main};
        display: block;
`
);

const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
        color: ${theme.palette.secondary.light}
`
);

function HeaderUserbox() {
  const { t }: { t: any } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [isConfirmationOpen, setConfirmationOpen] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const { user, logout } = useAuth();
  const avatar = user.gimageUrl
    ? user.gimageUrl
    : user.fbImageUrl
    ? user.fbImageUrl
    : '/static/images/avatars/avatar-1.jpg';

  const ref = useRef<any>(null);
  const [isOpen, setOpen] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState(false);
  const categoryTypeId = user?.categoryTypeId;

  useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
    };
  }, []);

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleCloseConfirmation = (): void => {
    if (isMounted) {
      setConfirmationOpen(false);
      setOpen(false);
    }
  };

  const handleLogout = async () => {
    // Open the confirmation modal

    setConfirmationOpen(true);
  };

  const handleConfirmLogout = async () => {
    try {
      // Perform the logout logic
      await logout();
      if (categoryTypeId === 'TCV') {
        navigate('/account/vendor/login');
      } else {
        navigate('/');
      }
    } catch (err) {
      console.error(err);
    } finally {
      // Close the confirmation modal
      handleCloseConfirmation();
    }
  };

  return (
    <>
      <UserBoxButton color="primary" ref={ref} onClick={handleOpen}>
        <Avatar variant="rounded" alt={user.name} src={avatar ? avatar : ''} />
        <Box
          component="span"
          sx={{
            display: { xs: 'none', md: 'inline-block' }
          }}
        >
          <UserBoxText>
            <UserBoxLabel variant="body1">{user.name}</UserBoxLabel>
            <UserBoxDescription variant="body2">
              {user.roleIdName}
            </UserBoxDescription>
          </UserBoxText>
        </Box>
        <Box
          component="span"
          sx={{
            display: { xs: 'none', sm: 'inline-block' }
          }}
        >
          <ExpandMoreTwoToneIcon
            sx={{
              ml: 1
            }}
          />
        </Box>
      </UserBoxButton>
      <Popover
        disableScrollLock
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuUserBox
          sx={{
            minWidth: 210
          }}
          display="flex"
        >
          <Avatar
            variant="rounded"
            alt={user.name}
            src={avatar ? avatar : ''}
          />
          <UserBoxText>
            <UserBoxLabel variant="body1">{user.name}</UserBoxLabel>
            <UserBoxDescription variant="body2">
              {user.roleIdName}
            </UserBoxDescription>
          </UserBoxText>
        </MenuUserBox>
        <Divider
          sx={{
            mb: 0
          }}
        />
        <List
          sx={{
            p: 1
          }}
          component="nav"
        >
          {/* <ListItem
            onClick={() => {
              handleClose();
            }}
            button
            to={`/${
              location.pathname.split('/')[1]
            }/dashboard/management/user-management/users/${user.id}`}
            component={NavLink}
          >
            <AccountBoxTwoToneIcon fontSize="small" />
            <ListItemText primary={t('Profile')} />
          </ListItem> */}

          <ListItem
            button
            onClick={() => {
              handleOpenDialog();
            }}
          >
            <LockResetTwoTone fontSize="small" />
            <ListItemText primary={t('Reset Password')} />
          </ListItem>
          {/* <ListItem
            button
            onClick={() => {
              handleClose();
            }}
            to="applications/projects-board"
            component={NavLink}
          >
            <AccountTreeTwoToneIcon fontSize="small" />
            <ListItemText primary={t('Projects')} />
          </ListItem> */}
        </List>
        <Divider />
        <Box m={1}>
          <Button
            color="primary"
            sx={{
              display: 'flex',
              flexDirection: 'row',
              padding: '9px 23px',
              gap: '4px',
              justifyContent: 'start',
              alignItems: 'center'
            }}
            fullWidth
            onClick={handleLogout}
          >
            <LockOpenTwoToneIcon
              fontSize="small"
              // sx={{
              //   mr: 1
              // }}
            />
            <span> {t('Sign Out')}</span>
          </Button>
          <LogoutConfirmation
            open={isConfirmationOpen}
            onClose={handleCloseConfirmation}
            onConfirm={handleConfirmLogout}
          />
        </Box>
      </Popover>
      <ResetPasswordAdmin
        open={openDialog}
        handleClose={handleCloseDialog}
        userId={user?.id}
      />
    </>
  );
}

export default HeaderUserbox;
